// CHEMARA — internationalization (DE default, EN, FR, IT)
// Vorerst nur Deutsch: die neuen Inhalte (lib/inhalte.js) gibt es noch nicht übersetzt. EN/FR/IT bleiben unten
// erhalten, sind aber nicht wählbar.
export const LANGUAGES = [
  { code: "de", label: "DE", name: "Deutsch" },
];
// ausgeblendet: { code: "en", label: "EN", name: "English" }, { code: "fr", label: "FR", name: "Français" },
//              { code: "it", label: "IT", name: "Italiano" }

export const DEFAULT_LANG = "de";

const T = {
  de: {
    nav: {
      divisions: "Geschäftsbereiche",
      projects: "Projekte",
      contact: "Kontakt",
      cta: "Kontakt aufnehmen",
    },
    hero: {
      brand_subtitle: "Schweizer Oberflächentechnologie",
      headline_part1: "Premium Oberflächentechnologien.",
      headline_emph: "Entwickelt in der Schweiz.",
      statement:
        "CHEMARA entwickelt und produziert hochwertige Beschichtungssysteme, Spezialchemikalien und fortschrittliche Oberflächentechnologien für Architektur, Industrie und exklusive Innenräume.",
      cta_explore: "Lösungen entdecken",
      cta_projects: "Projekte ansehen",
    },
    about: {
      label: "Über CHEMARA",
      heading_part1: "Ein Schweizer Unternehmen für Oberflächentechnologie und",
      heading_emph: "Spezialchemie.",
      p1: "CHEMARA entwickelt, formuliert und produziert hochwertige Oberflächensysteme — darunter Hochleistungsbeschichtungen, Spezialchemikalien und fortschrittliche Materialien — für industrielle, architektonische und kommerzielle Anwendungen.",
      p2: "Auf Basis von Schweizer Engineering und Qualitätsstandards entsteht jedes Produkt im eigenen Labor und wird unter kontrollierten Fertigungsbedingungen für konstant zuverlässige Leistung hergestellt.",
      origin: "Herkunft",
      origin_v: "Schweiz",
      discipline: "Disziplin",
      discipline_v: "Oberflächenchemie",
      manufacturing: "Produktion",
      manufacturing_v: "ISO-zertifiziert",
      markets: "Märkte",
      markets_v: "EU · Asien · MENA",
    },
    divisions: {
      label: "Unsere Geschäftsbereiche",
      heading_part1: "Sechs Bereiche.",
      heading_emph: "Ein Unternehmen.",
      intro:
        "CHEMARA agiert in sechs sich ergänzenden Geschäftsbereichen — von der Rohstoffbeschaffung über chemische Formulierung und Produktion bis hin zu Spezialmaterialien und angewandten Oberflächensystemen.",
      items: [
        {
          title: "Surface Technologies",
          summary:
            "Hochleistungs-Oberflächensysteme für Architektur, Retail und Industrie. Entwickelt für Langlebigkeit, Finish-Qualität und visuelle Tiefe.",
          tags: ["Harzsysteme", "Polierter Beton", "Mineralbeschichtungen"],
        },
        {
          title: "Industrial Coatings",
          summary:
            "Schutz- und Funktionsbeschichtungen für industrielle Umgebungen — Korrosionsschutz, chemische Beständigkeit und langfristige Leistung.",
          tags: ["Epoxid", "Polyurethan", "Korrosionsschutz"],
        },
        {
          title: "Chemical Manufacturing",
          summary:
            "Eigene Formulierung und Produktion von Spezialchemikalien und Harzsystemen — nach Schweizer Qualitätsstandards und ISO-zertifizierten Prozessen.",
          tags: ["Formulierung", "F&E", "Auftragssynthese"],
        },
        {
          title: "Contract Manufacturing",
          summary:
            "Lohnherstellung und Auftragsproduktion für Chemie- und Beschichtungsmarken. Vertrauliche Formulierung, Skalierung und Lieferung unter Schweizer Qualitätskontrolle.",
          tags: ["Lohnherstellung", "Private Label", "Scale-Up"],
        },
        {
          title: "Specialty Materials",
          summary:
            "Fortschrittliche Funktionsmaterialien und Oberflächenadditive für industrielle, architektonische und technische Anwendungen der nächsten Generation.",
          tags: ["Nano-Coatings", "Composites", "Funktionsadditive"],
        },
        {
          title: "Raw Material Trading",
          summary:
            "Beschaffung und Lieferung von industriellen und pharmazeutischen Rohstoffen über geprüfte Netzwerke in Europa, Asien und MENA.",
          tags: ["Polymere", "Harze", "Pigmente", "Lösungsmittel"],
        },
      ],
    },
    featured: {
      label: "Oberflächensysteme",
      heading_part1: "Nahtlose Premium-Oberflächen mit",
      heading_emph: "maximaler optischer Tiefe.",
      statement:
        "Monolithische Oberflächensysteme für Architektur, Industrie und exklusive Innenräume — entwickelt für visuelle Tiefe, Langlebigkeit und langfristige Leistung.",
    },
    stats: {
      label: "Kennzahlen",
      items: [
        "Aktive Märkte",
        "Bearbeitete Flächen",
        "Aktive Formulierungen",
        "Qualitätsindex",
      ],
    },
    philosophy: {
      label: "Unsere Philosophie",
      heading_part1: "Arranged",
      heading_emph: "Chemistry.",
      p1: "CHEMARA verbindet präzise Chemie, industrielles Engineering und hochwertige Finish-Qualität zu einer einzigen Disziplin. Jedes Oberflächensystem ist das Ergebnis bewusster Formulierung, kontrollierter Fertigung und klarem Fokus auf langfristige Leistung.",
      p2: "Das Resultat: Premium-Materialien und Beschichtungssysteme, die ihre Leistung über Jahre erbringen, bestehen und die Räume aufwerten, für die sie entwickelt wurden.",
      principles: [
        {
          title: "Präzision",
          body: "Schweizer Formulierung, entwickelt und geprüft unter kontrollierten Laborbedingungen für konsistente, zertifizierte Leistung.",
        },
        {
          title: "Performance",
          body: "Entwickelt für die anspruchsvollen Bedingungen von Industrie, Architektur und stark frequentierten Räumen.",
        },
        {
          title: "Finish-Qualität",
          body: "Hochwertiges visuelles Finish mit Tiefe, Klarheit und feinem Oberflächencharakter über jedes System hinweg.",
        },
      ],
      macro_label: "Beschichtungssystem · Makroaufnahme",
    },
    projects: {
      label: "Ausgewählte Projekte",
      heading_part1: "Referenzen aus",
      heading_emph: "Industrie und Architektur.",
      intro:
        "Oberflächensysteme, Beschichtungen und chemische Lösungen, realisiert für industrielle, gastronomische und architektonische Kunden in ganz Europa.",
      cta: "Vollständiges Portfolio anfragen",
      items: [
        { type: "Surface Technology", location: "Zürich, CH" },
        { type: "Coating System", location: "Genf, CH" },
        { type: "Chemical Manufacturing", location: "Basel, CH" },
        { type: "Specialty Material", location: "Lugano, CH" },
      ],
    },
    contact: {
      label: "Kontakt",
      heading_part1: "Projekt",
      heading_emph: "starten.",
      intro:
        "Für Projektanfragen, technische Fragen oder Lieferanfragen senden Sie uns einen kurzen Überblick. Unser Team antwortet persönlich innerhalb von 48 Stunden.",
      hq: "Hauptsitz",
      hq_address: "Roggenfarstrasse 4\n8193 Eglisau\nSchweiz",
      contact_label: "Kontakt",
      hours: "Geschäftszeiten",
      hours_v: "Mo – Fr · 08:00 – 18:00 MEZ",
      response: "Antwort innerhalb von 48 Stunden · Mo – Fr",
      fields: {
        name: "Name",
        name_ph: "Vor- und Nachname",
        email: "E-Mail",
        email_ph: "name@unternehmen.com",
        company: "Unternehmen",
        company_ph: "Organisation",
        project_type: "Projektart",
        project_type_ph: "Kategorie wählen",
        surface_area: "Fläche (m²)",
        surface_area_ph: "Ungefähr",
        timeline: "Zeitrahmen",
        timeline_ph: "z. B. Q2 2026",
        message: "Projektdetails",
        message_ph:
          "Beschreiben Sie das Projekt, die Anwendung, den Umfang und technische Anforderungen.",
      },
      project_types: [
        "Surface Technology",
        "Industrial Coating",
        "Chemical Manufacturing",
        "Contract Manufacturing",
        "Specialty Material",
        "Raw Material Sourcing",
      ],
      submit: "Anfrage senden",
      sending: "Wird gesendet",
      toast_error: "Bitte Name, E-Mail und Nachricht ausfüllen.",
      toast_network:
        "Verbindung zum Server fehlgeschlagen. Bitte später erneut versuchen oder direkt an info@chemara.ch schreiben.",
      toast_success:
        "Anfrage erhalten. Unser Team meldet sich innerhalb von 48 Stunden.",
    },
    footer: {
      tagline:
        "Schweizer Oberflächentechnologie, Spezialchemie und fortschrittliche Materialien.",
      office: "Büro",
      divisions: "Geschäftsbereiche",
      copyright: "CHEMARA · Swiss Made",
      legal: "Rechtliches",
      imprint: "Impressum",
      privacy: "Datenschutz",
    },
  },
  en: {
    nav: {
      divisions: "Divisions",
      projects: "Projects",
      contact: "Contact",
      cta: "Get in Touch",
    },
    hero: {
      brand_subtitle: "Swiss Surface Technologies",
      headline_part1: "Premium Surface Technologies.",
      headline_emph: "Engineered in Switzerland.",
      statement:
        "CHEMARA develops and manufactures high-performance coating systems, specialty chemicals and advanced surface technologies for architecture, industry and high-end interiors.",
      cta_explore: "Explore Solutions",
      cta_projects: "View Projects",
    },
    about: {
      label: "About CHEMARA",
      heading_part1: "A Swiss surface technology and",
      heading_emph: "specialty chemistry company.",
      p1: "CHEMARA develops, formulates and manufactures premium surface systems — including high-performance coatings, specialty chemicals and advanced materials — for industrial, architectural and commercial applications.",
      p2: "Built on Swiss engineering and quality standards, every product is developed in our own laboratory and produced under controlled manufacturing conditions for consistent, reliable performance.",
      origin: "Origin",
      origin_v: "Switzerland",
      discipline: "Discipline",
      discipline_v: "Surface Chemistry",
      manufacturing: "Manufacturing",
      manufacturing_v: "ISO-Audited",
      markets: "Markets",
      markets_v: "EU · Asia · MENA",
    },
    divisions: {
      label: "Our Divisions",
      heading_part1: "Six divisions.",
      heading_emph: "One company.",
      intro:
        "CHEMARA operates across six complementary business areas — covering the full value chain from raw material sourcing and chemical formulation to manufacturing, specialty materials and applied surface systems.",
      items: [
        {
          title: "Surface Technologies",
          summary:
            "High-performance seamless surface systems for architecture, retail and industrial environments. Engineered for durability, finish quality and visual depth.",
          tags: ["Resin Systems", "Polished Concrete", "Mineral Coatings"],
        },
        {
          title: "Industrial Coatings",
          summary:
            "Protective and functional coatings for industrial environments — corrosion control, chemical resistance and long-term operational performance.",
          tags: ["Epoxy", "Polyurethane", "Anti-Corrosion"],
        },
        {
          title: "Chemical Manufacturing",
          summary:
            "In-house formulation and production of specialty chemicals and resin systems — manufactured to Swiss quality and ISO-audited process standards.",
          tags: ["Formulation", "R&D", "Custom Synthesis"],
        },
        {
          title: "Contract Manufacturing",
          summary:
            "Toll and contract manufacturing for chemical and coating brands. Confidential formulation, scaling and supply under Swiss quality control.",
          tags: ["Toll Production", "Private Label", "Scale-Up"],
        },
        {
          title: "Specialty Materials",
          summary:
            "Advanced functional materials and surface additives engineered for next-generation industrial, architectural and technical applications.",
          tags: ["Nano-Coatings", "Composites", "Functional Additives"],
        },
        {
          title: "Raw Material Trading",
          summary:
            "Sourcing and supply of industrial and pharmaceutical-grade raw materials through audited European, Asian and MENA networks.",
          tags: ["Polymers", "Resins", "Pigments", "Solvents"],
        },
      ],
    },
    featured: {
      label: "Surface Systems",
      heading_part1: "Seamless premium surfaces with",
      heading_emph: "maximum optical depth.",
      statement:
        "Engineered monolithic surface systems for architecture, industry and high-end interiors — designed for visual depth, durability and long-term performance.",
    },
    stats: {
      label: "By the Numbers",
      items: [
        "Active Markets",
        "Surfaces Engineered",
        "Active Formulations",
        "Quality Index",
      ],
    },
    philosophy: {
      label: "Our Philosophy",
      heading_part1: "Arranged",
      heading_emph: "Chemistry.",
      p1: "CHEMARA combines precise chemistry, industrial engineering and refined finish quality into a single discipline. Every surface system we develop is the result of deliberate formulation, controlled manufacturing and a clear focus on long-term performance.",
      p2: "The result: premium materials and coating systems built to perform, endure and elevate the environments they are designed for.",
      principles: [
        {
          title: "Precision",
          body: "Swiss-grade formulation, developed and tested under controlled laboratory conditions for consistent, certified performance.",
        },
        {
          title: "Performance",
          body: "Engineered for the demanding conditions of industry, architecture and high-traffic commercial environments.",
        },
        {
          title: "Finish Quality",
          body: "High-end visual finish with depth, clarity and refined surface character across every system we develop.",
        },
      ],
      macro_label: "Coating System · Macro",
    },
    projects: {
      label: "Selected Projects",
      heading_part1: "References across",
      heading_emph: "industry and architecture.",
      intro:
        "Surface systems, coatings and chemical solutions delivered for industrial, hospitality and architectural clients across Europe.",
      cta: "Request Full Portfolio",
      items: [
        { type: "Surface Technology", location: "Zürich, CH" },
        { type: "Coating System", location: "Geneva, CH" },
        { type: "Chemical Manufacturing", location: "Basel, CH" },
        { type: "Specialty Material", location: "Lugano, CH" },
      ],
    },
    contact: {
      label: "Contact",
      heading_part1: "Start a",
      heading_emph: "project.",
      intro:
        "For project inquiries, technical questions or supply requests, please share a brief outline. Our team will respond personally within 48 hours.",
      hq: "Headquarters",
      hq_address: "Roggenfarstrasse 4\n8193 Eglisau\nSwitzerland",
      contact_label: "Contact",
      hours: "Hours",
      hours_v: "Mon – Fri · 08:00 – 18:00 CET",
      response: "Response within 48 hours · Mon – Fri",
      fields: {
        name: "Name",
        name_ph: "Full name",
        email: "Email",
        email_ph: "you@company.com",
        company: "Company",
        company_ph: "Organization",
        project_type: "Project Type",
        project_type_ph: "Select category",
        surface_area: "Surface Area (m²)",
        surface_area_ph: "Approximate",
        timeline: "Timeline",
        timeline_ph: "e.g. Q2 2026",
        message: "Project Details",
        message_ph:
          "Describe the project, application, scope and any technical requirements.",
      },
      project_types: [
        "Surface Technology",
        "Industrial Coating",
        "Chemical Manufacturing",
        "Contract Manufacturing",
        "Specialty Material",
        "Raw Material Sourcing",
      ],
      submit: "Send Inquiry",
      sending: "Sending",
      toast_error: "Please complete name, email and message.",
      toast_network:
        "Connection to the server failed. Please try again or email info@chemara.ch directly.",
      toast_success:
        "Inquiry received. Our team will respond within 48 hours.",
    },
    footer: {
      tagline:
        "Swiss surface technology, specialty chemistry and advanced materials.",
      office: "Office",
      divisions: "Divisions",
      copyright: "CHEMARA · Swiss Made",
      legal: "Legal",
      imprint: "Imprint",
      privacy: "Privacy",
    },
  },
  fr: {
    nav: {
      divisions: "Divisions",
      projects: "Projets",
      contact: "Contact",
      cta: "Nous contacter",
    },
    hero: {
      brand_subtitle: "Technologies de Surface Suisses",
      headline_part1: "Technologies de surface premium.",
      headline_emph: "Conçues en Suisse.",
      statement:
        "CHEMARA développe et fabrique des systèmes de revêtement haute performance, des produits chimiques spéciaux et des technologies de surface avancées pour l'architecture, l'industrie et les intérieurs haut de gamme.",
      cta_explore: "Découvrir les solutions",
      cta_projects: "Voir les projets",
    },
    about: {
      label: "À propos de CHEMARA",
      heading_part1: "Une entreprise suisse de technologie de surface et de",
      heading_emph: "chimie spécialisée.",
      p1: "CHEMARA développe, formule et fabrique des systèmes de surface premium — y compris des revêtements haute performance, des produits chimiques spéciaux et des matériaux avancés — pour des applications industrielles, architecturales et commerciales.",
      p2: "Fondés sur l'ingénierie et les normes de qualité suisses, tous les produits sont développés dans notre propre laboratoire et fabriqués dans des conditions contrôlées pour une performance constante et fiable.",
      origin: "Origine",
      origin_v: "Suisse",
      discipline: "Discipline",
      discipline_v: "Chimie de surface",
      manufacturing: "Fabrication",
      manufacturing_v: "Certifiée ISO",
      markets: "Marchés",
      markets_v: "UE · Asie · MENA",
    },
    divisions: {
      label: "Nos Divisions",
      heading_part1: "Six divisions.",
      heading_emph: "Une entreprise.",
      intro:
        "CHEMARA opère dans six domaines d'activité complémentaires — couvrant toute la chaîne de valeur, de l'approvisionnement en matières premières et la formulation chimique à la fabrication, aux matériaux spécialisés et aux systèmes de surface appliqués.",
      items: [
        {
          title: "Surface Technologies",
          summary:
            "Systèmes de surface sans joint haute performance pour l'architecture, le retail et l'industrie. Conçus pour la durabilité, la qualité de finition et la profondeur visuelle.",
          tags: ["Systèmes résine", "Béton poli", "Revêtements minéraux"],
        },
        {
          title: "Industrial Coatings",
          summary:
            "Revêtements protecteurs et fonctionnels pour environnements industriels — anti-corrosion, résistance chimique et performance à long terme.",
          tags: ["Époxy", "Polyuréthane", "Anti-corrosion"],
        },
        {
          title: "Chemical Manufacturing",
          summary:
            "Formulation et production internes de produits chimiques spéciaux et de systèmes résine — selon les standards de qualité suisses et processus certifiés ISO.",
          tags: ["Formulation", "R&D", "Synthèse sur mesure"],
        },
        {
          title: "Contract Manufacturing",
          summary:
            "Façonnage et production sous contrat pour marques chimiques et de revêtements. Formulation confidentielle, scaling et fourniture sous contrôle qualité suisse.",
          tags: ["Façonnage", "Marque privée", "Scale-Up"],
        },
        {
          title: "Specialty Materials",
          summary:
            "Matériaux fonctionnels avancés et additifs de surface conçus pour les applications industrielles, architecturales et techniques de nouvelle génération.",
          tags: ["Nano-revêtements", "Composites", "Additifs fonctionnels"],
        },
        {
          title: "Raw Material Trading",
          summary:
            "Sourcing et fourniture de matières premières industrielles et pharmaceutiques via des réseaux européens, asiatiques et MENA audités.",
          tags: ["Polymères", "Résines", "Pigments", "Solvants"],
        },
      ],
    },
    featured: {
      label: "Systèmes de Surface",
      heading_part1: "Surfaces premium sans joint avec",
      heading_emph: "une profondeur optique maximale.",
      statement:
        "Systèmes de surface monolithiques pour l'architecture, l'industrie et les intérieurs haut de gamme — conçus pour la profondeur visuelle, la durabilité et la performance à long terme.",
    },
    stats: {
      label: "En chiffres",
      items: [
        "Marchés actifs",
        "Surfaces traitées",
        "Formulations actives",
        "Indice qualité",
      ],
    },
    philosophy: {
      label: "Notre philosophie",
      heading_part1: "Arranged",
      heading_emph: "Chemistry.",
      p1: "CHEMARA combine chimie précise, ingénierie industrielle et qualité de finition raffinée en une seule discipline. Chaque système de surface est le résultat d'une formulation délibérée, d'une fabrication contrôlée et d'une focalisation claire sur la performance à long terme.",
      p2: "Le résultat : des matériaux premium et systèmes de revêtement conçus pour performer, durer et rehausser les espaces qu'ils habitent.",
      principles: [
        {
          title: "Précision",
          body: "Formulation de qualité suisse, développée et testée en laboratoire contrôlé pour une performance constante et certifiée.",
        },
        {
          title: "Performance",
          body: "Conçue pour les conditions exigeantes de l'industrie, de l'architecture et des espaces à fort trafic.",
        },
        {
          title: "Qualité de finition",
          body: "Finition visuelle haut de gamme — profondeur, clarté et caractère de surface raffiné sur chaque système.",
        },
      ],
      macro_label: "Système de revêtement · Macro",
    },
    projects: {
      label: "Projets sélectionnés",
      heading_part1: "Références à travers",
      heading_emph: "l'industrie et l'architecture.",
      intro:
        "Systèmes de surface, revêtements et solutions chimiques livrés à des clients industriels, hôteliers et architecturaux à travers l'Europe.",
      cta: "Demander le portfolio complet",
      items: [
        { type: "Surface Technology", location: "Zürich, CH" },
        { type: "Coating System", location: "Genève, CH" },
        { type: "Chemical Manufacturing", location: "Bâle, CH" },
        { type: "Specialty Material", location: "Lugano, CH" },
      ],
    },
    contact: {
      label: "Contact",
      heading_part1: "Démarrer un",
      heading_emph: "projet.",
      intro:
        "Pour toute demande de projet, question technique ou demande de fourniture, partagez-nous un bref aperçu. Notre équipe répond personnellement sous 48 heures.",
      hq: "Siège social",
      hq_address: "Roggenfarstrasse 4\n8193 Eglisau\nSuisse",
      contact_label: "Contact",
      hours: "Horaires",
      hours_v: "Lun – Ven · 08:00 – 18:00 CET",
      response: "Réponse sous 48 heures · Lun – Ven",
      fields: {
        name: "Nom",
        name_ph: "Nom complet",
        email: "E-mail",
        email_ph: "vous@entreprise.com",
        company: "Entreprise",
        company_ph: "Organisation",
        project_type: "Type de projet",
        project_type_ph: "Sélectionner une catégorie",
        surface_area: "Surface (m²)",
        surface_area_ph: "Approximative",
        timeline: "Délai",
        timeline_ph: "ex. T2 2026",
        message: "Détails du projet",
        message_ph:
          "Décrivez le projet, l'application, l'étendue et les exigences techniques.",
      },
      project_types: [
        "Surface Technology",
        "Industrial Coating",
        "Chemical Manufacturing",
        "Contract Manufacturing",
        "Specialty Material",
        "Raw Material Sourcing",
      ],
      submit: "Envoyer la demande",
      sending: "Envoi en cours",
      toast_error: "Veuillez compléter nom, e-mail et message.",
      toast_network:
        "Échec de la connexion au serveur. Veuillez réessayer ou envoyer un e-mail directement à info@chemara.ch.",
      toast_success:
        "Demande reçue. Notre équipe répondra sous 48 heures.",
    },
    footer: {
      tagline:
        "Technologie de surface suisse, chimie spécialisée et matériaux avancés.",
      office: "Bureau",
      divisions: "Divisions",
      copyright: "CHEMARA · Swiss Made",
      legal: "Mentions légales",
      imprint: "Mentions",
      privacy: "Confidentialité",
    },
  },
  it: {
    nav: {
      divisions: "Divisioni",
      projects: "Progetti",
      contact: "Contatti",
      cta: "Contattaci",
    },
    hero: {
      brand_subtitle: "Tecnologie di Superficie Svizzere",
      headline_part1: "Tecnologie di superficie premium.",
      headline_emph: "Progettate in Svizzera.",
      statement:
        "CHEMARA sviluppa e produce sistemi di rivestimento ad alte prestazioni, prodotti chimici speciali e tecnologie di superficie avanzate per architettura, industria e interni di alta gamma.",
      cta_explore: "Scopri le soluzioni",
      cta_projects: "Vedi i progetti",
    },
    about: {
      label: "Chi è CHEMARA",
      heading_part1: "Un'azienda svizzera di tecnologia di superficie e",
      heading_emph: "chimica specializzata.",
      p1: "CHEMARA sviluppa, formula e produce sistemi di superficie premium — inclusi rivestimenti ad alte prestazioni, prodotti chimici speciali e materiali avanzati — per applicazioni industriali, architettoniche e commerciali.",
      p2: "Fondati sull'ingegneria e sugli standard di qualità svizzeri, tutti i prodotti sono sviluppati nel nostro laboratorio e prodotti in condizioni controllate per una performance costante e affidabile.",
      origin: "Origine",
      origin_v: "Svizzera",
      discipline: "Disciplina",
      discipline_v: "Chimica di superficie",
      manufacturing: "Produzione",
      manufacturing_v: "Certificata ISO",
      markets: "Mercati",
      markets_v: "UE · Asia · MENA",
    },
    divisions: {
      label: "Le nostre divisioni",
      heading_part1: "Sei divisioni.",
      heading_emph: "Un'unica azienda.",
      intro:
        "CHEMARA opera in sei aree di business complementari — coprendo l'intera catena del valore, dall'approvvigionamento di materie prime e formulazione chimica alla produzione, ai materiali specialistici e ai sistemi di superficie applicati.",
      items: [
        {
          title: "Surface Technologies",
          summary:
            "Sistemi di superficie senza giunture ad alte prestazioni per architettura, retail e industria. Progettati per durata, qualità di finitura e profondità visiva.",
          tags: ["Sistemi resina", "Cemento lucidato", "Rivestimenti minerali"],
        },
        {
          title: "Industrial Coatings",
          summary:
            "Rivestimenti protettivi e funzionali per ambienti industriali — anticorrosione, resistenza chimica e prestazioni a lungo termine.",
          tags: ["Epossidico", "Poliuretano", "Anticorrosione"],
        },
        {
          title: "Chemical Manufacturing",
          summary:
            "Formulazione e produzione interna di prodotti chimici speciali e sistemi resina — secondo standard di qualità svizzeri e processi certificati ISO.",
          tags: ["Formulazione", "R&S", "Sintesi su misura"],
        },
        {
          title: "Contract Manufacturing",
          summary:
            "Produzione per conto terzi per marchi chimici e di rivestimento. Formulazione confidenziale, scaling e fornitura sotto controllo qualità svizzero.",
          tags: ["Produzione c/terzi", "Private Label", "Scale-Up"],
        },
        {
          title: "Specialty Materials",
          summary:
            "Materiali funzionali avanzati e additivi per superficie progettati per applicazioni industriali, architettoniche e tecniche di nuova generazione.",
          tags: ["Nano-rivestimenti", "Compositi", "Additivi funzionali"],
        },
        {
          title: "Raw Material Trading",
          summary:
            "Sourcing e fornitura di materie prime industriali e farmaceutiche tramite reti europee, asiatiche e MENA verificate.",
          tags: ["Polimeri", "Resine", "Pigmenti", "Solventi"],
        },
      ],
    },
    featured: {
      label: "Sistemi di superficie",
      heading_part1: "Superfici premium senza giunture con",
      heading_emph: "massima profondità ottica.",
      statement:
        "Sistemi di superficie monolitici per architettura, industria e interni di alta gamma — progettati per profondità visiva, durata e prestazioni a lungo termine.",
    },
    stats: {
      label: "I numeri",
      items: [
        "Mercati attivi",
        "Superfici realizzate",
        "Formulazioni attive",
        "Indice di qualità",
      ],
    },
    philosophy: {
      label: "La nostra filosofia",
      heading_part1: "Arranged",
      heading_emph: "Chemistry.",
      p1: "CHEMARA unisce chimica precisa, ingegneria industriale e qualità di finitura raffinata in un'unica disciplina. Ogni sistema di superficie è il risultato di una formulazione deliberata, produzione controllata e focus chiaro sulle prestazioni a lungo termine.",
      p2: "Il risultato: materiali premium e sistemi di rivestimento progettati per performare, durare ed elevare gli ambienti per cui sono concepiti.",
      principles: [
        {
          title: "Precisione",
          body: "Formulazione di livello svizzero, sviluppata e testata in laboratorio controllato per prestazioni costanti e certificate.",
        },
        {
          title: "Prestazione",
          body: "Progettata per le condizioni esigenti di industria, architettura e spazi ad alto traffico.",
        },
        {
          title: "Qualità di finitura",
          body: "Finitura visiva di alta gamma — profondità, chiarezza e carattere di superficie raffinato su ogni sistema.",
        },
      ],
      macro_label: "Sistema di rivestimento · Macro",
    },
    projects: {
      label: "Progetti selezionati",
      heading_part1: "Referenze tra",
      heading_emph: "industria e architettura.",
      intro:
        "Sistemi di superficie, rivestimenti e soluzioni chimiche realizzati per clienti industriali, dell'hospitality e architettonici in tutta Europa.",
      cta: "Richiedi il portfolio completo",
      items: [
        { type: "Surface Technology", location: "Zurigo, CH" },
        { type: "Coating System", location: "Ginevra, CH" },
        { type: "Chemical Manufacturing", location: "Basilea, CH" },
        { type: "Specialty Material", location: "Lugano, CH" },
      ],
    },
    contact: {
      label: "Contatti",
      heading_part1: "Avvia un",
      heading_emph: "progetto.",
      intro:
        "Per richieste di progetto, domande tecniche o richieste di fornitura, condividi un breve riepilogo. Il nostro team risponderà personalmente entro 48 ore.",
      hq: "Sede centrale",
      hq_address: "Roggenfarstrasse 4\n8193 Eglisau\nSvizzera",
      contact_label: "Contatti",
      hours: "Orari",
      hours_v: "Lun – Ven · 08:00 – 18:00 CET",
      response: "Risposta entro 48 ore · Lun – Ven",
      fields: {
        name: "Nome",
        name_ph: "Nome completo",
        email: "E-mail",
        email_ph: "tu@azienda.com",
        company: "Azienda",
        company_ph: "Organizzazione",
        project_type: "Tipo di progetto",
        project_type_ph: "Seleziona categoria",
        surface_area: "Superficie (m²)",
        surface_area_ph: "Approssimativa",
        timeline: "Tempistica",
        timeline_ph: "es. Q2 2026",
        message: "Dettagli del progetto",
        message_ph:
          "Descrivi il progetto, l'applicazione, l'ambito e i requisiti tecnici.",
      },
      project_types: [
        "Surface Technology",
        "Industrial Coating",
        "Chemical Manufacturing",
        "Contract Manufacturing",
        "Specialty Material",
        "Raw Material Sourcing",
      ],
      submit: "Invia richiesta",
      sending: "Invio in corso",
      toast_error: "Completa nome, e-mail e messaggio.",
      toast_network:
        "Connessione al server fallita. Riprovare o scrivere direttamente a info@chemara.ch.",
      toast_success:
        "Richiesta ricevuta. Il nostro team risponderà entro 48 ore.",
    },
    footer: {
      tagline:
        "Tecnologia di superficie svizzera, chimica specializzata e materiali avanzati.",
      office: "Ufficio",
      divisions: "Divisioni",
      copyright: "CHEMARA · Swiss Made",
      legal: "Legale",
      imprint: "Imprint",
      privacy: "Privacy",
    },
  },
};

export const getTranslations = (lang) => T[lang] || T[DEFAULT_LANG];
